import { createComponent } from '@mtfe/sweet';
import { eventBus, dom, lazyLoadImg } from '@mtfe/sweet-utils';
import { oadLX } from '@mtfe/pr-oad';
import { componentUtils } from '@mtfe/sweet-components';
import style from './style.less';
import tpl from './dom.html';
import { fetchDataList } from '../../../utils/fetchData';
import http from '../../../service/index';
import store from '../../../store/index';
import scrollLoading from '../../../utils/scrollLoading';

const scrollLoadingApply = 'b_waimai_u1an50iv_mv';
const { getOnClickEventName } = componentUtils;
const { storeCommon } = store;
const { startImgListener } = lazyLoadImg;

const InnerPoi = (props = {}) => {
    const { poiData, isOpenAutoLoading = true, renderFunc, onEnding } = props;
    const { poiContainerID, bottomTipID, giftId, recallBizId } = poiData;

    const data = {
        poiContainerID,
        bottomTipID,
    };

    const onClickEventName = getOnClickEventName(recallBizId, giftId);
    eventBus.$onceOn(onClickEventName, async () => {
        if (storeCommon.isLoading) {
            return;
        }
        try {
            const { poiList, pageNo } = poiData;
            const listDom = dom.$id(poiContainerID);

            if (pageNo === 1) {
                const poiInfo = await fetchDataList(poiData);
                poiList.push(...poiInfo);
            }
            listDom.innerHTML = poiList.map((poiInfo, poiIndex) => renderFunc(poiInfo, poiIndex, recallBizId)).join('');

            const { scrollLoadingInit, setEnding } = scrollLoading({
                dataList: poiList,
                reportObserve: http.gMonitorApi,
                renderItem: (poiInfo, itemIndex) => {
                    const res = renderFunc(poiInfo, itemIndex, recallBizId);
                    return res;
                },
                fetchDataList: async () => {
                    const res = await fetchDataList(poiData);
                    return res;
                },
                listContainerID: poiContainerID,
                bottomTipID,
                onEnding,
            });
            if (poiList.length === 0) {
                setEnding();
            } else if (!isOpenAutoLoading) {
                scrollLoadingInit();
                setEnding();
            } else {
                // 滚动加载执行
                oadLX.mv(scrollLoadingApply);
                scrollLoadingInit();
            }
            startImgListener();
        } catch (error) {
            console.error(error);
        }
    });

    const events = {};
    const component = createComponent(tpl, { data, style }, events);
    return component;
};

export default InnerPoi;
